/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Store} from '@gongxigames/framework/core';
import {FC, CanBeSignals, ContainerProps, getProp, PointLike} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';

import {IHitArea} from 'pixi.js';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';

export type ArrowButtonProps = Omit<ContainerProps, 'scale'> & CanBeSignals<{
    onPress?: () => void;
    flip?: boolean;
    hitArea: IHitArea | null;
}>;
export const $ArrowButton: FC<ArrowButtonProps> = (props) => {

    const flipScale = Store.computed(() => {
        const flip = getProp(props.flip);
        const x = flip ? -1 : 1;
        return [x, 1] as PointLike;
    });

    return <$Button {...props}
        name={LSViewConfig.arrowButtonParams.buttonName}
        hitArea={props.hitArea}
        action={props.onPress}
        scale={flipScale}
    />;

};